export default "__VITE_ASSET__0eh0rp4S__"